import { Component, Input, Renderer2, ElementRef, NgZone, ViewEncapsulation } from '@angular/core';
import { WorkItemTypeValue } from 'common/workitems/constants/workitem-types';
import { WidgetBase } from 'common/panel-layout/widget-base';
import { WorkItemChatPinInvite } from 'common/workitems/models/workitem-chat-pin-invite-model';
import { WorkItemListService } from 'common/workitems/workitem-list.service';
import { WorkAreaManager } from 'common/workitems/work-area-manager.service';
import { PinviteList } from 'common/workitems/lists/pinvite-list';
import { RxEmitter } from 'common/rxjs/rx-emitter';

@Component({
  selector: 'app-chat-pin-invite-widget',
  templateUrl: './chat-pin-invite-widget.component.html',
  styleUrls: ['./chat-pin-invite-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChatPinInviteWidgetComponent extends WidgetBase {
  @Input()
  public workItem: WorkItemChatPinInvite;

  public workItemTypeValue;
  public themeClass: string;

  constructor(
    element: ElementRef,
    workAreaManager: WorkAreaManager,
    private _workItemListService: WorkItemListService,
    private _appPinviteList: PinviteList,
    renderer: Renderer2,
    private _ngZone: NgZone,
    rxEmitter: RxEmitter
  ) {
    super(element.nativeElement, workAreaManager, renderer, rxEmitter);

    this.workItemTypeValue = WorkItemTypeValue;
  }

  onCancelInviteClick() {
    this._appPinviteList.removePendingChatPinvite(this.workItem.id)
      .then((workItem) => {
        if (workItem) {
          this._ngZone.run(() => {
            this._workItemListService.removeWorkItem(workItem);
          });
        }
      });
  }

  // code smell: unimplemented feature could be deleted safely
  _sendCannedMessagePanelAnalytics(_action) {
    /* block */
  }
}
